<template>
    <div>
        <data-table
                :id="state_identifier"
                :columns="visible_columns"
                :rows="filtered_rows"
                :search="state.search"
                :total="state.total"
                :found="state.found"
                :current-page="state.page"
                :total-pages="nb_pages"
                :searchable="false"
                table-class="uk-table-condensed uk-table-hover lam-subrecords-list"
                empty-title="No time off requests found"
                @sort="sort_by"
                @search="search"
                @page="goto_page"
                @click="edit"
            >
                <template
                    v-slot:controls
                >
                    <div class="lam-list-filters">
                        <ul slot="filters" class="uk-tab" data-uk-tab>
                            <li :class="{'uk-active': state.filter==='pending'}">
                                <a href @click.prevent="filter('request_status', 'pending')">Pending</a>
                            </li>
                            <li :class="{'uk-active': state.filter==='approved'}">
                                <a href @click.prevent="filter('request_status', 'approved')">Approved</a>
                            </li>
                            <li :class="{'uk-active': state.filter==='declined'}">
                                <a href @click.prevent="filter('request_status', 'declined')">Declined</a>
                            </li>
                            <li :class="{'uk-active': !state.filter}">
                                <a href @click.prevent="filter('request_status', '')">All</a>
                            </li>
                        </ul>
                    </div>
                </template>
                <template
                    v-slot:summary="{ row }"
                >
                    <h6>
                        {{ row.user_initials }}
                    </h6>
                </template>
                <template
                    v-slot:tbody="{ row, field }"
                >
                    <span v-if="field == 'starts_at_as_string'">
                        <span v-if="!!row.starts_at_as_string">{{ row.starts_at_as_string | nibnut.date("MMMM DD, YYYY", "-") }}</span>
                        <i v-else>{{ row.requested_starts_at_as_string | nibnut.date("MMMM DD, YYYY", "-") }}</i>
                    </span>
                    <span v-else-if="field == 'ends_at_as_string'">
                        <span v-if="!!row.ends_at_as_string">{{ row.ends_at_as_string | nibnut.date("MMMM DD, YYYY", "-") }}</span>
                        <i v-else>{{ row.requested_ends_at_as_string | nibnut.date("MMMM DD, YYYY", "-") }}</i>
                    </span>
                    <span v-else-if="field === 'nb_days'">{{ row.nb_days | nibnut.number("0,0") }}</span>
                    <span v-else>{{ row[field] }}</span>
            </template>
        </data-table>

        <modal-dialog
            id="time-off-request-manager"
            :show.sync="editing"
        >
            <template v-slot:title>
                <h2 v-if="!!edited_request">Time Off Request for {{ edited_request.user_initials }}</h2>
            </template>
            <template v-slot:footer>
                <div class="uk-grid">
                    <div class="uk-width-1-3">
                        <base-button
                            :disabled="rejecting||accepting"
                            size="large"
                            width="1-1"
                            @click.prevent="close"
                        >
                            Cancel
                        </base-button>
                    </div>
                    <div class="uk-width-1-3">
                        <base-button
                            :waiting="rejecting"
                            :disabled="rejecting||accepting"
                            color="danger"
                            size="large"
                            width="1-1"
                            @click.prevent="deny"
                        >
                            <open-icon glyph="thumbs-down" /> Deny
                        </base-button>
                    </div>
                    <div class="uk-width-1-3">
                        <base-button
                            :waiting="accepting"
                            :disabled="rejecting||accepting"
                            color="success"
                            size="large"
                            width="1-1"
                            @click.prevent="accept"
                        >
                            <open-icon glyph="thumbs-up" /> Approve
                        </base-button>
                    </div>
                </div>
            </template>

            <form v-if="!!edited_request" class="uk-form" role="form">
                <div class="uk-panel uk-panel-box uk-margin-bottom">
                    <h4 class="uk-panel-title">Requested: {{ request_date_range }}</h4>
                    <div v-if="!!edited_request.message" class="uk-grid uk-grid-small" data-uk-grid-margin>
                        <div class="uk-width-1-1">
                            <p>{{ edited_request.message }}</p>
                        </div>
                    </div>
                </div>

                <div class="uk-panel uk-panel-box">
                    <h4 class="uk-panel-title">Admin Details</h4>

                    <div class="uk-grid uk-grid-small" data-uk-grid-margin>
                        <div class="uk-width-1-1">
                            <form-date-range-control
                                id="response"
                                name="starts_at"
                                end-name="ends_at"
                                calendar-position="bottom"
                                v-model="response"
                                :editable="true"
                                :required="true"
                                :legacy="false"
                            />
                        </div>
                    </div>

                    <div class="uk-grid uk-grid-small" data-uk-grid-margin>
                        <div class="uk-width-1-1">
                            <h5>Response</h5>
                            <textarea v-model="response.response" class="uk-width-1-1"></textarea>
                        </div>
                    </div>
                </div>
            </form>
        </modal-dialog>
    </div>
</template>

<script type="text/javascript">
import dashboard_card from "./dashboard_card"
import is_remote_data_table_source from "../../mixins/IsRemoteDataTableSource"
import handles_saving from "../../mixins/HandlesSaving"
import string_utilities from "../../mixins/StringUtilities"

import ModalDialog from "../../dialogs/ModalDialog/ModalDialog"
import FormDateRangeControl from "../../ui/FormDateRangeControl"
import BaseButton from "../../ui/BaseButton"
import OpenIcon from "../../ui/OpenIcon"

export default {
    mixins: [dashboard_card, is_remote_data_table_source, handles_saving, string_utilities],
    components: {
        ModalDialog,
        FormDateRangeControl,
        BaseButton,
        OpenIcon
    },
    methods: {
        edit (row) {
            this.edited_request = row

            this.response.starts_at = this.start_date(this.edited_request)
            this.response.ends_at = this.end_date(this.edited_request)
            this.response.response = ""

            this.editing = true

            this.$store.dispatch("RECORD_SAVE", {
                entity: "time_off_request",
                id: this.edited_request.id,
                data: { viewed_at: this.$moment().format("YYYY-MM-DD") }
            }).then(() => {
            }).catch(error => {
                if(error) console.log(error)
            })
        },
        close () {
            this.editing = false
            this.edited_request = null
            this.rejecting = false
            this.accepting = false
        },
        start_date (record) {
            return this.$moment(record.starts_at || record.requested_starts_at).startOf("day")
        },
        end_date (record) {
            return this.$moment(record.ends_at || record.requested_ends_at).endOf("day")
        },
        save (status, waiter) {
            this[waiter] = true
            this.response.starts_at = this.$moment(this.response.starts_at).format("YYYY-MM-DD")
            this.response.ends_at = this.$moment(this.response.ends_at).format("YYYY-MM-DD")
            this.response.request_status = status

            this.$store.dispatch("RECORD_SAVE", {
                entity: "time_off_request",
                id: this.edited_request.id,
                data: this.response
            }).then(response => {
                this.close()
            }).catch(error => {
                if(error) console.log(error)
            }).then(() => {
                this[waiter] = false
            })
        },
        deny () {
            this.save("declined", "rejecting")
        },
        accept () {
            this.save("approved", "accepting")
        }
    },
    computed: {
        state_identifier () {
            return `Dashboard-${this.card.type}`
        },
        visible_columns () {
            const { requested_starts_at_as_string, requested_ends_at_as_string, message, ...visible_columns } = this.columns
            return visible_columns
        },
        request_date_range () {
            if(!this.edited_request.id) return ""

            const start_date = this.start_date(this.edited_request)
            const end_date = this.end_date(this.edited_request)
            let range = start_date.format("MM-DD-YYYY")
            if(!start_date.isSame(end_date, "day")) range += " to " + end_date.format("MM-DD-YYYY") + " (" + this.number_of_weekdays_in_range(start_date, end_date) + " days)"
            else range += " (1 day)"
            return range
        }
    },
    data () {
        return {
            entity: "time_off_request",
            columns: {
                user_initials: { label: "Staff", sort: null, type: "plain", cell_class: "lam-col-user-initials" },
                starts_at_as_string: { label: "From", sort: null, type: "plain" },
                ends_at_as_string: { label: "To", sort: null, type: "plain" },
                requested_starts_at_as_string: { label: "From", sort: false, type: "plain" },
                requested_ends_at_as_string: { label: "To", sort: false, type: "plain" },
                nb_days: { label: "Nb Days", sort: false, type: "plain" },
                request_status: { label: "Status", sort: false, type: "plain" },
                message: { label: "Message", sort: false, type: "plain" }
            },
            default_state: {
                per_page: 10,
                page: 1,
                sort_by: "starts_at_as_string",
                sort_dir: "asc",
                filter_on: "request_status",
                filter: "pending",
                archived: false,
                search: "",
                total: 0,
                found: 0,
                context: "dashboard",
                activated_at: 0
            },

            editing: false,
            edited_request: null,
            response: {
                starts_at: null,
                ends_at: null,
                response: ""
            },
            rejecting: false,
            accepting: false
        }
    }
}
</script>
